<template>
    <div class="expenses-container">
      <h1>Expenses</h1>
  
      <!-- Filters -->
      <div class="filters">
        <input type="text" v-model="filters.description" placeholder="Search by Description..." class="search-input"/>
        <input type="date" v-model="filters.startDate" class="search-input"/>
        <input type="date" v-model="filters.endDate" class="search-input"/>
      </div>
  
      <button @click="openAddPopup" class="add-button">Add Expense</button>
  
      <!-- Expenses Table -->
      <div class="table-container">
        <table class="expenses-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Category</th>
              <th>Purchase Date</th>
              <th>Cost</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>            
            <tr v-for="expense in sortedExpenses" :key="expense?.id">
              <td>{{ expense.description }}</td>
              <td>{{ expense.category_name }}</td>
              <td>{{ new Date(expense.purchase_date).toLocaleDateString('en-US') }}</td>
              <td>${{ expense.cost.toFixed(2) }}</td>
              <td class="action-buttons">
                <button @click="openEditPopup(expense)" class="edit-button">Edit</button>
                <button @click="confirmDelete(expense)" class="delete-button">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Add/Edit Expense Popup -->
<div v-if="showPopup" class="popup-container">
  <div class="popup">
    <h2 class="popup-title">{{ editing ? 'Edit Expense' : 'Add Expense' }}</h2>
    <form @submit.prevent="submitExpense" class="popup-form">
      
      <label class="popup-label">Description:
        <input type="text" v-model="currentExpense.description" required class="popup-input" />
      </label>

      <label class="popup-label">Category:
        <select v-model="currentExpense.category_id" required class="popup-select">
          <option value="" disabled>Select a category</option>
          <option v-for="category in categories" :key="category.category_id" :value="category.category_id">
            {{ category.category_name }}
          </option>
        </select>
      </label>

      <label class="popup-label">Purchase Date:
        <input type="date" v-model="currentExpense.purchase_date" required class="popup-input" />
      </label>

      <label class="popup-label">Cost:
        <input type="number" v-model="currentExpense.cost" step="0.01" required class="popup-input" />
      </label>

      <div class="popup-buttons">
        <button type="submit" class="save-button">Save</button>
        <button type="button" @click="showPopup = false" class="cancel-button">Cancel</button>
      </div>
    </form>
  </div>
</div>
    </div>
  </template>
  
  <script>
  import api from '@/services/api';
  
  export default {
    data() {
      return {
        expenses: [],
        categories: [],
        showPopup: false,
        editing: false,
        filters: { description: '', startDate: '', endDate: '' },
        currentExpense: { id: null, description: '', category_id: '', purchase_date: '', cost: '' },
      };
    },
    computed: {

      sortedExpenses() {
        return this.filteredExpenses.slice().sort((a, b) => a.id - b.id);
      },

      filteredExpenses() {
        return this.expenses.filter(expense =>
          (!this.filters.description || expense.description.toLowerCase().includes(this.filters.description.toLowerCase())) &&
          (!this.filters.startDate || expense.purchase_date >= this.filters.startDate) &&
          (!this.filters.endDate || expense.purchase_date <= this.filters.endDate)
        );
      }
    },
    methods: {
        async fetchExpenses() {
        const response = await api.get('/expenses');
        this.expenses = response.data.map(expense => ({
            ...expense,
            cost: Number(expense.cost)
        }));
    },
  
    async fetchCategories() {
      const response = await api.get('/expense-categories');
      this.categories = response.data;
    },
  
      openAddPopup() {
        this.currentExpense = { id: null, description: '', category_id: '', purchase_date: '', cost: '' };
        this.editing = false;
        this.showPopup = true;
      },
      openEditPopup(expense) {
        this.currentExpense = { ...expense };
        this.editing = true;
        this.showPopup = true;
      },
      async submitExpense() {
        if (this.editing) {
          await api.put(`/expenses/${this.currentExpense.id}`, this.currentExpense);
        } else {
          await api.post('/expenses', this.currentExpense);
        }
        this.showPopup = false;
        this.fetchExpenses();
      },
      async confirmDelete(expense) {
        if (confirm("Are you sure you want to delete this expense?")) {
          await api.delete(`/expenses/${expense.id}`);
          this.fetchExpenses();
        }
      }
    },
    mounted() {
      this.fetchExpenses();
      this.fetchCategories();
    }
  };
  </script>

  
  <style scoped>

  
  .expenses-container {
    padding: 20px;
    font-family: "Poppins", sans-serif !important;
    background: #9cd0f2;
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .filters {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .search-input {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #b0c4de;
    background: #e6eef3;
  }
  
  .add-button, .save-button, .cancel-button, .edit-button, .delete-button {
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
  }
  
  .add-button { background-color: #288671; color: white; }
  .add-button:hover { background-color: #237a4b; }
  
  .save-button { background-color: #327ba8; color: white; }
  .save-button:hover { background-color: #286c98; }
  
  .cancel-button { background-color: #4f6773; color: white; }
  .cancel-button:hover { background-color: #3a4a5e; }
  
  .edit-button { background-color: #3a4a5e; color: white; }
  .edit-button:hover { background-color: #2a3a4a; }
  
  .delete-button { background-color: #9f3207; color: white; }
  .delete-button:hover { background-color: #1f2a35; }
  
  .table-container {
    background: #eef4fb;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .expenses-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .expenses-table th, .expenses-table td {
    border: 1px solid #83a7cb;
    padding: 8px;
    text-align: center;
  }
  
  .expenses-table tr:hover { background-color: #e0f2f1; }
  
  .popup-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 50vw;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
}

.popup-title {
  margin-bottom: 15px;
  font-size: 1.5rem;
  font-weight: bold;
}

.popup-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.popup-label {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  margin-bottom: 10px;
}

.popup-input, .popup-select {
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #b0c4de;
  background: #e6eef3;
  width: 100%;
}

.popup-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
</style>
